import React, { useState, useEffect } from 'react';
import './BookingTimer.css';

const BookingTimer = ({ onTimeout, startTime }) => {
    const [timeLeft, setTimeLeft] = useState(() => {
        if (!startTime) return 600; // 10 minutes in seconds
        const timeLeftMs = new Date(startTime).getTime() + (600 * 1000) - new Date().getTime();
        return Math.max(0, Math.floor(timeLeftMs / 1000));
    });

    useEffect(() => {
        // Always start the timer, even if startTime is not set
        const timeLeftMs = startTime 
            ? new Date(startTime).getTime() + (600 * 1000) - new Date().getTime()
            : 600 * 1000;
        const initialTimeLeft = Math.max(0, Math.floor(timeLeftMs / 1000));
        
        if (initialTimeLeft <= 0) {
            onTimeout();
            return;
        }

        setTimeLeft(initialTimeLeft);
        
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    onTimeout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [startTime, onTimeout]);

    // Only render if we have time left
    if (timeLeft <= 0) return null;

    return (
        <div className="booking-timer">
            Rezervasyon süresi: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, '0')}
        </div>
    );
};

export default BookingTimer; 